import { z } from "zod";

/** Search params shared by every project screen. `env` is the environment scope (slug). */
export const projectSearch = z.object({ env: z.string().optional() });
export type ProjectSearch = z.infer<typeof projectSearch>;

export const DEFAULT_ENV = "prod";

/** Keeps the environment scope when navigating between project screens. */
export const keepEnv = (prev: Partial<ProjectSearch>): ProjectSearch =>
  prev.env && prev.env !== DEFAULT_ENV ? { env: prev.env } : {};
